import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { SectionCard } from 'src/components/shared/SectionCard'

/**
 * Rendered when the fetch succeeded and returned no configuration row. Deliberately has no form
 * and no Save: `PUT …/buyer` 404s without a row, and a zero-filled form would read as "every fee
 * on this customer is 0" — a claim about live pricing the backend never made.
 */
const PaymentConfigEmptyCardComponent = () => {
  return (
    <SectionCard title="No payment configuration">
      <Typography variant="body2" css={tw`text-shades-500`} data-testid="payment-config-empty">
        This customer has no payment configuration, so payout settings and vendor fees cannot be
        edited here. Customers created before payment configuration became automatic need one added
        before their pricing can be managed.
      </Typography>
    </SectionCard>
  )
}

export const PaymentConfigEmptyCard = memo(PaymentConfigEmptyCardComponent)
